export const MainBio = () => {
  return (
    <div className=" flex-col w-11/12 justify-center my-8">
        <div className="text-center my-2 w-2/3 mx-auto">        
            <h2 className="mx-autopy-6 w-1/3 text-2xl md:text-3xl dark:text-slate-300 inline font-notoSans">Hi, my name is </h2><span className="text-sky-800 dark:text-yellow-500 text-2xl md:text-3xl tracking-wide inline md:font-oswald w-1/2">Lukáš Hotový</span>
        </div>
        <h1 className="mx-auto text-center py-4 text-2xl md:text-3xl dark:text-slate-300 font-notoSans">I am test automation specialist <span className="text-sky-800 dark:text-yellow-500 text-2xl tracking-wide md:text-3xl inline md:font-oswald w-1/2">and junior software developer</span> </h1>
    </div>
  );
};
